/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthControllerAuthorizeByFirebaseMutationRequest,
  TelegramAuthControllerAuthorizeByFirebaseMutationResponse,
  TelegramAuthControllerAuthorizeByFirebase401,
  TelegramAuthControllerAuthorizeByFirebase403,
} from '../types/TelegramAuthControllerAuthorizeByFirebase.ts';

function getTelegramAuthAuthorizeByFirebaseUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/firebase` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/firebase}
 */
export async function telegramAuthAuthorizeByFirebase(
  data: TelegramAuthControllerAuthorizeByFirebaseMutationRequest,
  config: Partial<RequestConfig<TelegramAuthControllerAuthorizeByFirebaseMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthControllerAuthorizeByFirebaseMutationResponse,
    ResponseErrorConfig<TelegramAuthControllerAuthorizeByFirebase401 | TelegramAuthControllerAuthorizeByFirebase403>,
    TelegramAuthControllerAuthorizeByFirebaseMutationRequest
  >({
    method: 'POST',
    url: getTelegramAuthAuthorizeByFirebaseUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
